// extracted by mini-css-extract-plugin
export var wrapper = "team-composition-list-module--wrapper--Pc90x";
export var supercoach = "team-composition-list-module--supercoach--0p3Qp";
export var coach = "team-composition-list-module--coach--EsA8q";
export var developer = "team-composition-list-module--developer--Hy4LK";
export var surrounded = "team-composition-list-module--surrounded--W81Wl";
export var qa = "team-composition-list-module--qa--LdCa6";
export var productOwner = "team-composition-list-module--product-owner--lfLCq";
export var designer = "team-composition-list-module--designer--5eJkQ";